import React from 'react';
import classNames from 'classnames';
import Heading from "@scentregroup/ui/components/heading";
import Image from "@scentregroup/ui/components/image";
import Paragraph from "@scentregroup/ui/components/paragraph";
import Grid from '../grid';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SQUARE_THRESHOLD = 4;
export const FeaturedLinksGrid = _ref => {
  let {
    Link,
    featuredLinks,
    itemsPerRow,
    title,
    className,
    square = itemsPerRow >= SQUARE_THRESHOLD,
    trackers
  } = _ref;
  const ratio = square ? 'square' : 'standard';
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(style.FeaturedLinksGrid, className),
    "data-id": "featured-links-grid_index_FeaturedLinksGrid_div",
    children: [title && /*#__PURE__*/_jsx(Heading, {
      type: "small",
      className: style.heading,
      "data-id": "featured-links-grid_index_FeaturedLinksGrid_Heading",
      children: title
    }), /*#__PURE__*/_jsx(Grid, {
      itemsPerRow: itemsPerRow,
      "data-id": "featured-links-grid_index_FeaturedLinksGrid_div_Grid",
      children: featuredLinks.map((featuredLink, index) => /*#__PURE__*/_jsxs(Link, {
        to: featuredLink.url,
        className: classNames(style.FeaturedLink, 'sc-slot', "sc-slot-".concat(index), "ad-content-".concat(featuredLink.url.split('/')[2])),
        "data-test-id": "featured-links-grid",
        onClick: () => {
          var _trackers$clicked;

          return trackers === null || trackers === void 0 ? void 0 : (_trackers$clicked = trackers.clicked) === null || _trackers$clicked === void 0 ? void 0 : _trackers$clicked.call(trackers, featuredLink.title);
        },
        "data-id": "featured-links-grid_index_FeaturedLinksGrid_Link",
        children: [/*#__PURE__*/_jsx(Image, {
          imageUrl: featuredLink.imageUrl,
          className: style.image,
          ratio: ratio,
          bgSize: "cover",
          type: "mobile",
          "data-id": "featured-links-grid_index_FeaturedLinksGrid_Link_Image"
        }), /*#__PURE__*/_jsx(Paragraph, {
          className: style.paragraph,
          "data-id": "featured-links-grid_index_FeaturedLinksGrid_Link_Paragraph",
          children: featuredLink.title
        })]
      }, "".concat(featuredLink.imageUrl, "-").concat(featuredLink.title, "-").concat(featuredLink.url)))
    })]
  });
};